setTimeout(() => {
    let varriantOption = document.querySelectorAll('[bss-b2b-variant-click]')
    if (varriantOption.length) {
        varriantOption.forEach((e) => {
            e.addEventListener("click", function(e) {
                setTimeout(async () => {
                    let variantId = document.querySelector('.product-form__variants.no-js').value
                    let price = document.querySelector('.product-single__price[bss-b2b-variant-id]')
                    if (variantId) {
                        price.setAttribute('bss-b2b-variant-id', variantId)
                    }
                }, 100)

            });
        })
    }


    document.querySelectorAll('[bss-b2b-btn-quickview]').forEach((e) => {
        e.addEventListener("click", function(e) {


            setTimeout( () => {
               let form =  document.querySelector('[bss-b2b-quickview-product-form_ver2]')
              if (form) {
                form.setAttribute('bss-b2b-quickview-product-form', '');
              }
            }, 1000)
          
            setTimeout(async () => {
                // const res = await BSS_B2B.storage.productStorage.load();
                // BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', res)
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
              
                // let varriantOption = document.querySelectorAll('select.option.size')
                // if (varriantOption.length) {
                //     varriantOption.forEach((e) => {
                //         e.addEventListener("change", function(e) {
                //             setTimeout(async () => {
                                
                //                 const res = await BSS_B2B.storage.productStorage.load();

                //                 if (res.variantIds?.size) {
                //                     let variantID = Number(document.querySelector('.qv-product-price').getAttribute('bss-b2b-variant-id'))
                //                     let productID = Number(document.querySelector('.qv-product-price').getAttribute('bss-b2b-product-id'))
                //                     // res.variantIds.set(productID, [variantId])
                //                     let product = BSS_B2B.storage.productStorage.get(Number(productID))
                //                     // if (product && product.variants) {
                //                     //     const  variant = product.variants.filter(variantId => variantId.id == variantID)[0]
                //                     //           console.log('product', variant, product.variants.filter(variantId => variantId.id == variantID) )
                //                     //     if (variant) {
                //                     //       variant.bssB2bShowPriceKey = "cp"
                //                     //       product.currentVariant = variant
                //                     //        console.log('product', product , variantID )
                //                     //       BSS_B2B.storage.productStorage.delete(productID)
                                           
                //                     //       BSS_B2B.storage.productStorage.set(productID, product)
                //                     //         BSS_B2B.storage.variantStorage.set(variantID, {
                //                     //             productId: productID,
                //                     //             ...variant,
                //                     //         });
                //                     //     }
                //                     // }
          
                //                     BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', res)
                //                 }

                //             }, 1500)
                //         });
                //     })
                // }
            }, 2000)
        });
    })
}, 2500)